let resumeData = {
  "imagebaseurl": "https://hemuu12.github.io/",
  "name": "Hari Singh Bisht",
  "role": "Full Stack Developer",
  "phone": "+91-9675286699",
  "linkedinId": "hari-singh-bisht",
  "roleDescription": "Full Stack Developer with experience building scalable, high-performance web applications using React, Next.js, Node.js, and TypeScript. Strong expertise in REST API integration, backend optimization, and system design.",
  "socialLinks": [
    {
      "name": "LinkedIn",
      "url": "https://www.linkedin.com/in/hari-singh-bisht/",
      "className": "fa fa-linkedin"
    },
    {
      "name": "GitHub",
      "url": "https://github.com/hemuu12",
      "className": "fa fa-github"
    },
    {
      "name": "Email",
      "url": "mailto:harisingh.bisht2001@gmail.com",
      "className": "fa fa-envelope"
    }
  ],
  "aboutme": "Full Stack Developer with experience building scalable, high-performance web applications using React, Next.js, Node.js, and TypeScript. Strong expertise in REST API integration, backend optimization, and system design. Proven ability to improve performance and deliver production-grade solutions in fast-paced environments. I thrive in collaborative, client-facing roles and take ownership of end-to-end product delivery.",
  "address": "Rudrapur, Uttarakhand, India",
  "email": "harisingh.bisht2001@gmail.com",
  "website": "https://hemuu12.github.io",
  "resumeDownload": "Hari_Bisht_Resume.pdf",
  "education": [
    {
      "UniversityName": "Masai School",
      "specialization": "Full Stack Development Course",
      "MonthOfPassing": "Mar",
      "YearOfPassing": "2023",
      "Achievements": "Intensive full-stack web development program. 1200+ hours of hands-on coding, collaborative projects, Data Structures & Algorithms, and System Design."
    },
    {
      "UniversityName": "Kumaun University",
      "specialization": "Bachelor of Computer Applications (BCA)",
      "MonthOfPassing": "",
      "YearOfPassing": "2018 - 2021",
      "Achievements": "Built strong foundations in Computer Science, Databases, Networking, and Software Engineering principles."
    }
  ],
  "work": [
    {
      "CompanyName": "Manhattan Tech Ventures",
      "specialization": "Full Stack Developer (Client-Facing) | Remote",
      "MonthOfLeaving": "Present",
      "YearOfLeaving": "",
      "startDate": "Nov 2025",
      "Achievements": "Developed a full-stack advertising platform integrating 49 Amazon DSP APIs. Built scalable frontend (React, TypeScript) and backend services (Node.js). Designed a hybrid RBAC system improving permission validation by 50-100x (under 1ms latency). Also coordinated development of Social Club Mumbai — a membership-based booking and lifestyle platform."
    },
    {
      "CompanyName": "1View Solutions Pvt. Ltd.",
      "specialization": "Full Stack Developer",
      "MonthOfLeaving": "Nov",
      "YearOfLeaving": "2025",
      "startDate": "Apr 2024",
      "Achievements": "Developed and maintained full-stack applications using modern JavaScript technologies. Optimized SQL queries improving database performance. Built scalable REST APIs and improved data flow across systems. Enhanced system stability and reduced performance bottlenecks."
    },
    {
      "CompanyName": "ChainCode Consulting LLP",
      "specialization": "Junior Full Stack Developer",
      "MonthOfLeaving": "Feb",
      "YearOfLeaving": "2024",
      "startDate": "Apr 2023",
      "Achievements": "Built responsive web applications using React and Next.js. Integrated frontend with backend APIs for seamless data handling. Improved UI performance and reduced page load times."
    }
  ],
  "skillsDescription": "Technologies & tools I work with",
  "skills": [
    { "skillname": "JavaScript", "category": "language" },
    { "skillname": "TypeScript", "category": "language" },
    { "skillname": "React.js", "category": "frontend" },
    { "skillname": "Next.js", "category": "frontend" },
    { "skillname": "Redux Toolkit", "category": "frontend" },
    { "skillname": "HTML5", "category": "frontend" },
    { "skillname": "CSS3", "category": "frontend" },
    { "skillname": "Node.js", "category": "backend" },
    { "skillname": "Express.js", "category": "backend" },
    { "skillname": "REST APIs", "category": "backend" },
    { "skillname": "MongoDB", "category": "database" },
    { "skillname": "PostgreSQL", "category": "database" },
    { "skillname": "Prisma", "category": "database" },
    { "skillname": "Mongoose", "category": "database" },
    { "skillname": "RBAC", "category": "system" },
    { "skillname": "System Design", "category": "system" },
    { "skillname": "AWS S3", "category": "cloud" },
    { "skillname": "Git", "category": "cloud" },
    { "skillname": "GitHub", "category": "cloud" },
    { "skillname": "Linux", "category": "cloud" }
  ],
  "softSkills": [
    "Client Communication",
    "Problem Solving",
    "Cross-functional Collaboration",
    "Ownership & Accountability",
    "Technical Communication"
  ],
  "portfolio": [
    {
      "name": "SocialGear DSP",
      "description": "Full-stack Amazon advertising platform integrating 49 DSP APIs for campaign automation, asset management, and multi-user workflows with low-latency RBAC system.",
      "techStack": "React, TypeScript, Node.js, Express, MongoDB, AWS",
      "imgurl": "",
      "liveUrl": "",
      "githubUrl": ""
    },
    {
      "name": "Social Club Mumbai",
      "description": "Membership-based booking and lifestyle platform for a hospitality client. Features membership flows, booking systems, and user access control.",
      "techStack": "React, Node.js, WordPress, Vercel",
      "imgurl": "",
      "liveUrl": "",
      "githubUrl": ""
    },
    {
      "name": "Glowup",
      "description": "Full-stack cosmetics e-commerce platform with user authentication, product catalog, cart management, and payment integration.",
      "techStack": "React, Redux, Node.js, Express, MongoDB",
      "imgurl": "",
      "liveUrl": "https://glowup-com.netlify.app/",
      "githubUrl": "https://github.com/gk072745/nifty-wave-512"
    },
    {
      "name": "SocialHub",
      "description": "Social media post scheduling tool that lets users create, customize, and schedule posts across multiple platforms.",
      "techStack": "React, Redux, JavaScript, CSS",
      "imgurl": "",
      "liveUrl": "https://sociahubb.netlify.app/",
      "githubUrl": "https://github.com/VinayRinait/Buffer_Website_Clone"
    },
    {
      "name": "Yoox Fashion",
      "description": "Premium fashion e-commerce clone with product filtering, dynamic cart, responsive design, and seamless checkout flow.",
      "techStack": "React, JavaScript, HTML, CSS",
      "imgurl": "",
      "liveUrl": "https://my-app-hemuu12.vercel.app/",
      "githubUrl": "https://github.com/hemuu12/My-Yoox-"
    },
    {
      "name": "YouTube Clone",
      "description": "Video streaming platform clone with ad-free viewing, search functionality, and responsive video player.",
      "techStack": "HTML, CSS, JavaScript",
      "imgurl": "",
      "liveUrl": "https://lively-moonbeam-8eb446.netlify.app/",
      "githubUrl": "https://github.com/hemuu12/youtube-clone"
    }
  ],
  "testimonials": [
    {
      "description": "Hari consistently delivers clean, production-grade code and takes full ownership of features from design to deployment. His RBAC system design was a standout — it improved our permission checks by 50-100x.",
      "name": "Manhattan Tech Ventures"
    },
    {
      "description": "A reliable developer who brings both technical depth and strong communication skills. Hari's ability to translate client requirements into working software made him an invaluable part of our team.",
      "name": "Project Collaborator"
    }
  ]
}

export default resumeData
